/**
 * A single CALC leaf term: `<<field>> op value`, or a bare yes/no field when
 * the operator is "is true". Placeholder rows show just the field picker until
 * a field is chosen.
 */
import React from "react"
import { Select, Input, Button, Tooltip } from "antd"
import { DeleteOutlined } from "@ant-design/icons"
import {
  CalcComparison,
  CalcNode,
  CalcOp,
  CalcPlaceholder,
  COMPARISON_OPS,
  newComparison,
} from "./calcExpression"
import CalcFieldPicker from "./CalcFieldPicker.component"

interface CalcConditionRowProps {
  node: CalcComparison | CalcPlaceholder
  onChange: (next: CalcNode) => void
  onDelete?: () => void
  onWrapInNot?: () => void
}

const CalcConditionRow: React.FC<CalcConditionRowProps> = ({
  node,
  onChange,
  onDelete,
  onWrapInNot,
}) => {
  if (node.kind === "placeholder") {
    return (
      <div className="qc-calc-row">
        <CalcFieldPicker
          value=""
          onChange={(field) => onChange(newComparison(field))}
          placeholder="Pick a field to begin…"
        />
        {onDelete && (
          <Tooltip title="Remove">
            <Button
              type="text"
              size="small"
              icon={<DeleteOutlined />}
              onClick={onDelete}
            />
          </Tooltip>
        )}
      </div>
    )
  }

  const cmp = node
  return (
    <div className="qc-calc-row">
      <CalcFieldPicker
        value={cmp.field}
        onChange={(field) => onChange({ ...cmp, field })}
      />
      <Select<CalcOp>
        size="small"
        value={cmp.op}
        onChange={(op) => onChange({ ...cmp, op })}
        options={COMPARISON_OPS}
        style={{ minWidth: 150 }}
        popupMatchSelectWidth={false}
      />
      {cmp.op !== "truthy" && (
        <Input
          size="small"
          value={cmp.value}
          onChange={(e) => onChange({ ...cmp, value: e.target.value })}
          placeholder="value (e.g. 1)"
          style={{ width: 110 }}
          className="qc-mono"
        />
      )}
      {onWrapInNot && (
        <Tooltip title="Negate this condition (NOT)">
          <Button size="small" onClick={onWrapInNot}>
            NOT
          </Button>
        </Tooltip>
      )}
      {onDelete && (
        <Tooltip title="Remove">
          <Button
            type="text"
            size="small"
            icon={<DeleteOutlined />}
            onClick={onDelete}
          />
        </Tooltip>
      )}
    </div>
  )
}

export default CalcConditionRow
